import React from 'react';
import { useSelector } from 'react-redux';

import {
  selectTranscriptWithLocalCorrections,
  selectTranscriptionStatus,
} from 'selectors/transcripts';

import * as TRANSCRIPTION from '../../../../../../shared/constants/videoTranscript';
import EmptyTranscript from '../emptyTranscript';
import TranscriptList from '../transcript-list';
import { Transcript } from 'utilities/transcript/types';
import { TranscriptionStatus } from '../../../../../../shared/constants/videoTranscript';

const TranscriptWrapper = ({
  setShowFullHeader,
}: {
  setShowFullHeader: (v: boolean) => void;
}): JSX.Element => {
  const transcriptStatus = useSelector<unknown, TranscriptionStatus>(
    selectTranscriptionStatus
  );
  const transcript = useSelector<unknown, Transcript>(
    selectTranscriptWithLocalCorrections
  );

  return transcript ? (
    <TranscriptList
      transcript={transcript}
      setShowFullHeader={setShowFullHeader}
    />
  ) : (
    <EmptyTranscript
      failed={
        transcriptStatus === TRANSCRIPTION.FAILED ||
        transcriptStatus === TRANSCRIPTION.SHORT_DURATION ||
        !TRANSCRIPTION.TRANSCRIPTION_STATUSES.includes(transcriptStatus)
      }
      empty={transcriptStatus === TRANSCRIPTION.NO_AUDIO}
    />
  );
};

export default TranscriptWrapper;
